export default () => {
  ['mesoRegion', 'macroRegion', 'legionRegion', 'B2W-PID'].map(
    cookie => (document.cookie = `${cookie}=;path=/;expires=Thu, 01 Jan 1970 00:00:00 UTC;`)
  );
};
